import React from 'react';
import { Button } from './ui/button';
import { ArrowDown, Sparkles } from 'lucide-react';

const Hero = () => {
  const scrollToBooks = () => {
    const booksSection = document.querySelector('#books');
    if (booksSection) {
      booksSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="min-h-screen flex items-center justify-center relative overflow-hidden">
      {/* Background with gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-sage-50 via-rose-50 to-sage-100"></div>
      
      {/* Decorative elements */}
      <div className="absolute top-20 left-10 w-32 h-32 bg-rose-200/30 rounded-full blur-xl"></div>
      <div className="absolute bottom-40 right-20 w-48 h-48 bg-sage-200/30 rounded-full blur-xl"></div>
      <div className="absolute top-1/2 left-1/4 w-24 h-24 bg-rose-300/20 rounded-full blur-lg"></div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="mb-8">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/70 backdrop-blur-sm rounded-full border border-sage-200 mb-6">
            <Sparkles className="text-rose-500" size={16} />
            <span className="text-sage-700 text-sm font-medium">Autora de romances</span>
          </div>
          
          <h1 className="text-5xl md:text-7xl font-bold text-sage-800 mb-6 leading-tight">
            Luisa
            <span className="block text-rose-600">Landre</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-sage-600 mb-8 max-w-3xl mx-auto leading-relaxed">
            Escritora de comédias românticas, literatura sáfica e ficção especulativa
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <Button 
            onClick={scrollToBooks}
            size="lg"
            className="bg-rose-500 hover:bg-rose-600 text-white px-8 py-3 text-lg transition-all duration-300 transform hover:scale-105"
          >
            Conheça Meus Livros
          </Button>
          
          <Button 
            variant="outline"
            size="lg"
            onClick={() => document.querySelector('#about').scrollIntoView({ behavior: 'smooth' })}
            className="border-sage-300 text-sage-700 hover:bg-sage-50 px-8 py-3 text-lg transition-all duration-300"
          >
            Sobre a Autora
          </Button>
        </div>

        {/* Scroll indicator */}
        <div className="animate-bounce">
          <ArrowDown className="mx-auto text-sage-400" size={24} />
        </div>
      </div>

      {/* Featured books preview - floating cards */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 hidden lg:flex gap-4">
        <div className="w-16 h-24 bg-white rounded-lg shadow-lg border border-sage-200 opacity-60 transform rotate-12 hover:opacity-90 transition-all duration-300"></div>
        <div className="w-16 h-24 bg-white rounded-lg shadow-lg border border-rose-200 opacity-80 transform -rotate-6 hover:opacity-100 transition-all duration-300"></div>
        <div className="w-16 h-24 bg-white rounded-lg shadow-lg border border-sage-200 opacity-60 transform rotate-3 hover:opacity-90 transition-all duration-300"></div>
      </div>
    </section>
  );
};

export default Hero;